import { render, staticRenderFns } from "./AnchorItem.vue?vue&type=template&id=14de24d2"
import script from "./AnchorItem.vue?vue&type=script&lang=js"
export * from "./AnchorItem.vue?vue&type=script&lang=js"
import style0 from "./AnchorItem.vue?vue&type=style&index=0&id=14de24d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports